import React, { useContext, useEffect, useState } from "react";
import { ClientContext } from "../../context/Client/ClientContext";

const ClassList = ({ handleClassClick, classList }) => {
  const [clsListLocal, setClsListLocal] = useState([]);

  const { setSelectedClass, selectedClass, hideClientList } =
    useContext(ClientContext);

  useEffect(() => {
    setClsListLocal(classList || []);
  }, [classList]);

  const handleClass = (cls) => {
    handleClassClick(cls.id);
    setSelectedClass(cls);
    hideClientList();
  };

  return (
    <div className="gog-dept-picker-list">
      <div className="gog-dept-picker-header">
        <span>Step 2</span>
        <h4>Type</h4>
        <p>Select the matching business type.</p>
      </div>

      <div className="gog-dept-picker-items">
        {clsListLocal.length > 0 ? (
          clsListLocal.map((cls) => {
            const isSelected = cls.id === selectedClass?.id;

            return (
              <button
                key={cls.id}
                type="button"
                className={`gog-dept-picker-item ${
                  isSelected ? "active" : ""
                }`}
                onClick={() => handleClass(cls)}
              >
                <span>{cls.name}</span>
                {isSelected && <b>✓</b>}
              </button>
            );
          })
        ) : (
          <div className="gog-dept-empty">
            Select a category to view types.
          </div>
        )}
      </div>
    </div>
  );
};

export default ClassList;